import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getTenant(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createTenant(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/tenant" + pathname, body);
}

export async function updateTenant(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/tenant" + pathname + queryParams, body);
}

export async function deleteTenant(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/tenant" + pathname + queryParams);
}
